'use client'

import {useEffect} from 'react'

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (config: {portalId: string; formId: string; target: string; region?: string}) => void
      }
    }
  }
}

interface Props {
  portalId: string
  formId: string
  region?: string
}

export const HubspotForm = ({portalId, formId, region = 'eu1'}: Props) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = '//js.hsforms.net/forms/embed/v2.js'
    script.async = true
    script.defer = true
    document.body.appendChild(script)

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId,
          target: '#hubspot-form-container',
          region,
        })
      }
    })

    return () => {
      document.body.removeChild(script)
    }
  }, [portalId, formId, region])

  return <div id="hubspot-form-container" />
}
